<template>
  <div class="page page-trackDevice">
    <h2>Новое устройство</h2>
    <div class="row">
      <div class="col-md-6 mb-2">
        <label>Название</label>
        <input type="text" class="form-control" v-model="trackDevice.name" placeholder required />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 mb-2">
        <label>IMEI</label>
        <input type="text" class="form-control" v-model="trackDevice.imei" placeholder required />
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 mb-2">
        <label>Тип прошивки</label>
        <v-select
          :options="firmwares"
          v-model="trackDevice.firmware_id"
          :reduce="firmware => firmware.id"
          label="name"
        />
      </div>
    </div>
    <hr class="mb-4" />
    <button class="btn btn-primary" @click="createTrackDevice()">Создать</button>
  </div>
</template>
<script>
import Swal from 'sweetalert2'
import trackDevicesAPI from '@/api/track-devices'

export default {
  name: 'createTrackDevice',
  mounted () {
    trackDevicesAPI.getFirmwares().then(response => {
      this.firmwares = response
    })
  },
  data () {
    return {
      trackDevice: {},
      firmwares: []
    }
  },
  methods: {
    createTrackDevice () {
      if (this.isCreating) {
        return
      }
      this.isCreating = true
      trackDevicesAPI.createItem(this.trackDevice)
        .then(trackDevice => {
          this.isCreating = false
          this.$router.push(`/devices/${trackDevice.model.id}`)
        })
        .catch(text => {
          this.isCreating = false
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: text.message
          })
        })
    }
  }
}
</script>
<style scoped>
  .page-track-device .btn-primary {
    width: 8rem;
    float: right !important;
  }
  .page-track-device h2 {
    margin-bottom: 3rem;
  }
  .page-track-device {
    padding-bottom: 8rem;
  }
</style>
